import {
  FETCH_BOOKINGS,
  FETCH_BOOKINGS_SUCCESS,
  FETCH_BOOKINGS_FAILED,
  UPDATE_BOOKING,
  CANCEL_BOOKING
} from "../store/types";
import { fetchBookingLocations } from '../actions/locationactions';
import { RequestPushMsg } from '../other/NotificationFunctions';
import store from '../store/store';
import { firebase } from '../config/configureFirebase';
import { get, onValue, update, off, remove, push } from "firebase/database";
import { uploadBytesResumable, getDownloadURL } from "firebase/storage";

export const fetchBookings = () => (dispatch) => {

  const {
    bookingListRef,
  } = firebase;

  dispatch({
    type: FETCH_BOOKINGS,
    payload: null,
  });

  const userInfo = store.getState().auth.profile;

  off(bookingListRef(userInfo.uid, userInfo.usertype));
  onValue(bookingListRef(userInfo.uid, userInfo.usertype),(snapshot) => {
    if (snapshot.val()) {
      const data = snapshot.val();
      const active = [];
      let tracked = null;
      const bookings = Object.keys(data)
        .filter(key => userInfo.usertype !== 'fleetadmin' || (userInfo.usertype === 'fleetadmin' && (data[key].fleetadmin === userInfo.uid || data[key].fleetadminrider === userInfo.uid)))
        .map((i) => {
          data[i].id = i;
          data[i].pickupAddress = data[i].pickup.add;
          data[i].dropAddress = data[i].drop.add;
          data[i].discount = data[i].discount
            ? data[i].discount
            : 0;
          data[i].cashPaymentAmount = data[i].cashPaymentAmount
            ? data[i].cashPaymentAmount
            : 0;
          data[i].cardPaymentAmount = data[i].cardPaymentAmount
            ? data[i].cardPaymentAmount
            : 0;
          return data[i];
        });
      for (let i = 0; i < bookings.length; i++) {
        if (['PAYMENT_PENDING','NEW', 'ACCEPTED', 'ARRIVED', 'STARTED', 'REACHED', 'PENDING', 'PAID'].indexOf(bookings[i].status) != -1) {
          active.push(bookings[i]);
        }
        if ((['ACCEPTED', 'ARRIVED', 'STARTED'].indexOf(bookings[i].status) != -1) && userInfo.usertype == 'driver') {
          tracked = bookings[i];
          fetchBookingLocations(tracked.id)(dispatch);
        }
      }
      dispatch({
        type: FETCH_BOOKINGS_SUCCESS,
        payload: {
          bookings: bookings.reverse(),
          active: active,
          tracked: tracked
        },
      });
      if (tracked) {
        dispatch({
          type: FETCH_BOOKINGS_SUCCESS,
          payload: null
        });
      }
    } else {
      dispatch({
        type: FETCH_BOOKINGS_FAILED,
        payload: store.getState().languagedata.defaultLanguage.no_bookings,
      });
    }
  });
};


export const updateBooking = (booking) => async (dispatch) => {

  const {
    auth,
    trackingRef,
    singleBookingRef,
    singleUserRef,
    settingsRef,
    userRatingsRef
  } = firebase;

  dispatch({
    type: UPDATE_BOOKING,
    payload: booking,
  });

  const settingsdata = await get(settingsRef);
  const settings = settingsdata.val();
  
  if (booking.status == 'PAYMENT_PENDING') {
    update(singleBookingRef(booking.id),booking);
  }
  if (booking.status == 'NEW' || booking.status == 'ACCEPTED') {
    if(booking.hasBid){
      if(booking.driver && booking.prepaid){
        booking.status = "ACCEPTED";
      }
      update(singleUserRef(booking.driver),{ queue: true });
    }
    update(singleBookingRef(booking.id),booking);
  }
  if (booking.status == 'ARRIVED') {
    let dt = new Date();
    booking.driver_arrive_time = dt.getTime().toString();
    update(singleBookingRef(booking.id),booking);
    if(booking.customer_token){
      RequestPushMsg(
        booking.customer_token,
        {
          title: store.getState().languagedata.defaultLanguage.notification_title,
          msg: store.getState().languagedata.defaultLanguage.driver_near,
          screen: 'BookedCab',
          params: { bookingId: booking.id }
        }
      );
    }
  }
  if (booking.status == 'STARTED') {
    let dt = new Date();
    let localString = dt.getHours() + ":" + dt.getMinutes() + ":" + dt.getSeconds();
    let timeString = dt.getTime();
    booking.trip_start_time = localString;
    booking.startTime = timeString;
    update(singleBookingRef(booking.id),booking);

    const driverLocation = store.getState().gpsdata.location;
    
    push(trackingRef(booking.id),{
      at: new Date().getTime(),
      status: 'STARTED',
      lat: driverLocation.lat,
      lng: driverLocation.lng
    });
    if(booking.customer_token){
      RequestPushMsg(
        booking.customer_token,
        {
          title: store.getState().languagedata.defaultLanguage.notification_title,
          msg: store.getState().languagedata.defaultLanguage.driver_journey_msg + booking.reference,
          screen: 'BookedCab',
          params: { bookingId: booking.id }
        }
      );
    }
  }
  if (booking.status == 'REACHED') {

    const driverLocation = store.getState().gpsdata.location;

    push(trackingRef(booking.id),{
      at: new Date().getTime(),
      status: 'REACHED',
      lat: driverLocation.lat,
      lng: driverLocation.lng
    });

    const end_time = new Date();
    const diff = (end_time.getTime() - parseFloat(booking.startTime)) / 1000;
    const totalTimeTaken = Math.abs(Math.round(diff));
    booking.trip_end_time = end_time.getHours() + ":" + end_time.getMinutes() + ":" + end_time.getSeconds();
    booking.endTime = end_time.getTime();
    booking.total_trip_time = totalTimeTaken;
    
    update(singleBookingRef(booking.id),booking);
    if(booking.customer_token){
      RequestPushMsg(
        booking.customer_token,
        {
          title: store.getState().languagedata.defaultLanguage.notification_title,
          msg: store.getState().languagedata.defaultLanguage.driver_completed_ride,
          screen: 'BookedCab',
          params: { bookingId: booking.id }
        }
      );
    }
  }
  if (booking.status == 'PENDING') {
    update(singleBookingRef(booking.id),booking);
    update(singleUserRef(booking.driver), { queue: false });
  }
  if (booking.status == 'PAID') {
    if(booking.booking_from_web){
      booking.status = 'COMPLETE';
    }
    update(singleBookingRef(booking.id), booking);
    if(booking.driver == auth.currentUser.uid && (booking.prepaid || booking.payment_mode == 'cash' || booking.payment_mode == 'wallet')){
      update(singleUserRef(booking.driver), { queue: false });
    }

    if(booking.customer_token){
      RequestPushMsg(
        booking.customer_token,
        {
          title: store.getState().languagedata.defaultLanguage.notification_title,
          msg: store.getState().languagedata.defaultLanguage.success_payment,
          screen: 'BookedCab',
          params: { bookingId: booking.id }
        }
      );
    }

      if(booking.driver_token){
        RequestPushMsg(
          booking.driver_token,
          {
              title: store.getState().languagedata.defaultLanguage.notification_title,
              msg: store.getState().languagedata.defaultLanguage.success_payment,
              screen: 'BookedCab',
              params: { bookingId: booking.id }
          }
        );
      }
  }
  if (booking.status == 'COMPLETE') {
    update(singleBookingRef(booking.id), booking);
    if (booking.rating) {
      if(booking.driver_token){
        RequestPushMsg(
          booking.driver_token,
          {
              title: store.getState().languagedata.defaultLanguage.notification_title,
              msg:  store.getState().languagedata.defaultLanguage.received_rating.toString().replace("X", booking.rating.toString()),
              screen: 'BookedCab',
              params: { bookingId: booking.id }
          }
        );
      }
      
      onValue(userRatingsRef(booking.driver), snapshot => {
        let ratings = snapshot.val();
        let rating;
        if(ratings){
          let sum = 0;
          const arr = Object.values(ratings);
          for (let i = 0; i< arr.length ; i++){
            sum = sum + arr[i].rate
          }
          sum = sum + booking.rating;
          rating = parseFloat(sum / (arr.length + 1)).toFixed(1);
        }else{
          rating =  booking.rating;
        }
        update(singleUserRef(booking.driver),{rating: rating});
        push(userRatingsRef(booking.driver), {
          user: booking.customer,
          rate: booking.rating
        });
      }, { onlyOnce: true});
    }
  }
};

export const cancelBooking = (data) => (dispatch) => {
  const {
    singleBookingRef,
    singleUserRef,
    requestedDriversRef
  } = firebase;

  dispatch({
    type: CANCEL_BOOKING,
    payload: data,
  });

  update(singleBookingRef(data.booking.id),{
    status: 'CANCELLED',
    reason: data.reason,
    cancelledBy: data.cancelledBy
  }).then(() => {
    if (data.booking.driver && ( data.booking.status === 'NEW' || data.booking.status === 'ACCEPTED' || data.booking.status === 'ARRIVED')) {
      update(singleUserRef(data.booking.driver),{ queue: false });
      if(data.booking.driver_token){
        RequestPushMsg(
          data.booking.driver_token,
          {
              title: store.getState().languagedata.defaultLanguage.notification_title,
              msg:  store.getState().languagedata.defaultLanguage.booking_cancelled + data.booking.id,
              screen: 'BookedCab',
              params: { bookingId: data.booking.id }
          }
        );
      }
      if(data.booking.customer_token){
        RequestPushMsg(
          data.booking.customer_token,
          {
              title: store.getState().languagedata.defaultLanguage.notification_title,
              msg:  store.getState().languagedata.defaultLanguage.booking_cancelled + data.booking.id,
              screen: 'BookedCab',
              params: { bookingId: data.booking.id }
          }
        );
      }
    }
    if (data.booking.status === 'NEW') {
      remove(requestedDriversRef(data.booking.id));
    }
  });
};

// Auto Search specific cancellation - keeps booking in NEW status for auto search
export const cancelBookingForAutoSearch = (data) => (dispatch, getState) => {
  const {
    singleBookingRef,
    singleUserRef,
    requestedDriversRef,
    config
  } = firebase;

  dispatch({
    type: 'CANCEL_BOOKING_FOR_AUTO_SEARCH',
    payload: data,
  });
  
  // This action is specifically for auto search, so always keep in NEW status
  const updateData = {
    status: 'NEW',
    reason: data.reason,
    cancelledBy: data.cancelledBy,
    wasAccepted: true,
    previousDriver: data.booking.driver,
    previousDriverToken: data.booking.driver_token,
    automaticSearch: true
  };

  update(singleBookingRef(data.booking.id), updateData).then(() => {
    // Remove driver from queue
    if (data.booking.driver) {
      update(singleUserRef(data.booking.driver), { queue: false });
      
      // Notify driver about cancellation
      if (data.booking.driver_token) {
        RequestPushMsg(
          data.booking.driver_token,
          {
            title: store.getState().languagedata.defaultLanguage.notification_title,
            msg: store.getState().languagedata.defaultLanguage.booking_cancelled + data.booking.id,
            screen: 'BookedCab',
            params: { bookingId: data.booking.id },
            channelId: 'general',
            sound: Platform.OS === 'android' ? 'general' : 'general.mp3'
          }
        );
      }
    }
    
    // Notify customer about cancellation and auto search
    if (data.booking.customer_token) {
      RequestPushMsg(
        data.booking.customer_token,
        {
          title: store.getState().languagedata.defaultLanguage.notification_title,
          msg: 'Driver cancelled your trip. Auto search is now active to find a new driver.',
          screen: 'BookedCab',
            params: { bookingId: data.booking.id },
            channelId: 'general',
            sound: Platform.OS === 'android' ? 'general' : 'general.mp3'
        }
      );
    }
    
    // Remove requested drivers for this booking
    remove(requestedDriversRef(data.booking.id));
  });
};

// Auto Search action - finds and assigns available drivers to booking
export const searchForAvailableDrivers = (booking) => async (dispatch, getState) => {
  console.log('🔄 Auto Search: Starting search for available drivers for booking:', booking.id);
  
  const {
    singleBookingRef,
    settingsRef,
    usersRef,
    allLocationsRef,
    requestedDriversRef
  } = firebase;

  try {
    // Import the helper function from adminQueueActions
    const { getAvailableDrivers } = await import('./adminQueueActions');
    
    // Get settings for driver radius
    const settingsSnapshot = await get(settingsRef);
    const settings = settingsSnapshot.val() || {};
    const driverRadius = settings.driverRadius || 10;
    
    console.log('🔍 Auto Search: Searching for drivers within radius:', driverRadius, 'km');
    
    // Find available drivers
    const availableDrivers = await getAvailableDrivers(booking.pickup, driverRadius);
    
    if (availableDrivers && availableDrivers.length > 0) {
      console.log('✅ Auto Search: Found', availableDrivers.length, 'available drivers');
      
      // 🚫 EXCLUDE PREVIOUS DRIVER: Filter out the driver who cancelled
      const previousDriverId = booking.previousDriver || booking.driver;
      const filteredDrivers = availableDrivers.filter(driver => {
        const shouldExclude = driver.id === previousDriverId;
        if (shouldExclude) {
          console.log('🚫 Auto Search: Excluding previous driver:', driver.id, driver.name || 'Unknown');
        }
        return !shouldExclude;
      });
      
      console.log('✅ Auto Search: After excluding previous driver:', filteredDrivers.length, 'drivers remaining');
      
      if (filteredDrivers.length === 0) {
        console.log('❌ Auto Search: No drivers available after excluding previous driver');
        return { success: false, error: 'No available drivers found (previous driver excluded)' };
      }
      
      // Reset booking data for new search
      const resetBookingData = {
        status: 'NEW',
        requestedDrivers: {},
        driverEstimates: {},
        driverOffers: null,
        driver: null,
        driver_token: null,
        selectedBid: null,
        autoSearchActive: true,
        autoSearchTimestamp: new Date().toISOString()
      };
      
      // Add each available driver to requestedDrivers (excluding previous driver)
      filteredDrivers.forEach(driver => {
        resetBookingData.requestedDrivers[driver.id] = true;
        resetBookingData.driverEstimates[driver.id] = {
          distance: driver.distance,
          timein_text: (driver.distance * 2 + 1).toFixed(0) + " min"
        };
      });
      
      // Update booking in Firebase
      await update(singleBookingRef(booking.id), resetBookingData);
      
      // Send notifications to all available drivers (excluding previous driver)
      const language = store.getState().languagedata.defaultLanguage;
      
      for (const driver of filteredDrivers) {
        if (driver.token) {
          console.log('🔔 Auto Search: Sending notification to driver:', driver.id);
          
          RequestPushMsg(
            driver.token,
            {
              title: language.notification_title,
              msg: language.new_booking_notification,
              screen: 'DriverTrips',
              channelId: 'bookings-repeat',
              ios: driver.userPlatform === "IOS" ? true : false,
              sound: 'repeat.wav'
            }
          );
        }
      }
      
      // Update Redux store
      dispatch({
        type: UPDATE_BOOKING,
        payload: { ...booking, ...resetBookingData },
      });
      
      console.log('✅ Auto Search: Successfully sent booking to', filteredDrivers.length, 'drivers (previous driver excluded)');
      return { success: true, driversFound: filteredDrivers.length };
      
    } else {
      console.log('❌ Auto Search: No available drivers found');
      return { success: false, error: 'No available drivers found' };
    }
    
  } catch (error) {
    console.error('❌ Auto Search: Error searching for drivers:', error);
    return { success: false, error: error.message };
  }
};

// NEW: Special action for moving booking to admin queue
export const moveToAdminQueue = (booking) => async (dispatch) => {
  const {
    singleBookingRef,
  } = firebase;

  try {
    // Prepare updated booking data
    const updatedBooking = {
      ...booking,
      status: 'ADMIN_QUEUE',
      noDriversReason: 'User chose to wait for admin to find drivers',
      noDriversTimestamp: new Date().toISOString(),
      adminQueuePriority: 'normal',
      adminQueueNotes: 'Waiting for admin to find available drivers',
      estimatedWaitTime: '15-30 minutes',
      lastUpdated: new Date().toISOString()
    };

    // Update in Firebase
    await update(singleBookingRef(booking.id), updatedBooking);
    
    // Update Redux store
    dispatch({
      type: UPDATE_BOOKING,
      payload: updatedBooking,
    });
    console.log('✅ Redux store updated with ADMIN_QUEUE booking');
    
    // Refresh booking list to ensure UI shows updated data
    dispatch(fetchBookings());
    
    // Send notification to customer
    if (booking.customer_token) {
      RequestPushMsg(
        booking.customer_token,
        {
          title: store.getState().languagedata.defaultLanguage.notification_title || 'Admin Queue',
          msg: store.getState().languagedata.defaultLanguage.no_drivers_available_message || 'Your trip has been sent to Admin for driver assignment',
          screen: 'BookedCab',
          params: { bookingId: booking.id },
          channelId: 'general',
          sound: Platform.OS === 'android' ? 'general' : 'general.mp3'
        }
      );
    }
    
    // 🚀 SEND NOTIFICATION TO DRIVERS when order enters admin queue
    try {
      
      // Import admin queue actions
      const { sendAdminQueueNotification } = await import('./adminQueueActions');
      
      // Send notification to available drivers
      await sendAdminQueueNotification(booking.id, updatedBooking);
      
      console.log('🔔 Driver notification sent successfully');
      
    } catch (notificationError) {
      console.error('❌ Error sending driver notification:', notificationError);
      // Don't fail the whole operation if notification fails
    }

    return { success: true, booking: updatedBooking };
    
  } catch (error) {
    console.error('❌ Error moving booking to admin queue:', error);
    
    dispatch({
      type: FETCH_BOOKINGS_FAILED,
      payload: 'Failed to move booking to admin queue',
    });
    
    return { success: false, error: error.message };
  }
};

export const updateBookingImage = (booking, imageType, imageBlob) => async (dispatch) => {
  const   {
    singleBookingRef,
    bookingImageRef
  } = firebase;
  await uploadBytesResumable(bookingImageRef(booking.id,imageType), imageBlob).then(() => {
    imageBlob.close()
    return getDownloadURL(bookingImageRef(booking.id,imageType))
  }).then((url) => {
    if(imageType == 'pickup_image'){
      booking.pickup_image = url;
    }
    if(imageType == 'deliver_image'){
      booking.deliver_image = url;
    }
    update(singleBookingRef(booking.id), booking);
    dispatch({
      type: UPDATE_BOOKING,
      payload: booking,
    });
  })
};

export const forceEndBooking = (booking) => async (dispatch) => {

  const {
    trackingRef,
    singleBookingRef,
    singleUserRef,
    walletHistoryRef,
    settingsRef,
  } = firebase;

  dispatch({
    type: UPDATE_BOOKING,
    payload: booking,
  });
  
  if (booking.status == 'STARTED') {

    push(trackingRef(booking.id),{
      at: new Date().getTime(),
      status: 'REACHED',
      lat: booking.drop.lat,
      lng: booking.drop.lng
    });

    const end_time = new Date();
    const diff = (end_time.getTime() - parseFloat(booking.startTime)) / 1000;
    const totalTimeTaken = Math.abs(Math.round(diff));
    booking.trip_end_time = end_time.getHours() + ":" + end_time.getMinutes() + ":" + end_time.getSeconds();
    booking.endTime = end_time.getTime();
    booking.total_trip_time = totalTimeTaken;

    if(booking.customer_token){
      RequestPushMsg(
        booking.customer_token,
        {
            title: store.getState().languagedata.defaultLanguage.notification_title,
            msg: store.getState().languagedata.defaultLanguage.driver_completed_ride,
            screen: 'BookedCab',
            params: { bookingId: booking.id }
        }
      );
    }

    update(singleUserRef(booking.driver),{ queue: false });

    if(booking.prepaid){

      const settingsdata = await get(settingsRef);
      const settings = settingsdata.val();

      onValue(singleUserRef(booking.driver), snapshot => {
        let walletBalance = parseFloat(snapshot.val().walletBalance);
        walletBalance = walletBalance + parseFloat(booking.driver_share);
        if(parseFloat(booking.cashPaymentAmount)>0){
          walletBalance = walletBalance - parseFloat(booking.cashPaymentAmount);
        }
        update(singleUserRef(booking.driver),{"walletBalance": parseFloat(walletBalance.toFixed(settings.decimal))});

        let details = {
          type: 'Credit',
          amount: parseFloat(booking.driver_share).toFixed(settings.decimal),
          date: new Date().getTime(),
          txRef: booking.id
        }
        push(walletHistoryRef(booking.driver),details);
        
        if(parseFloat(booking.cashPaymentAmount)>0){
          let details = {
            type: 'Debit',
            amount: booking.cashPaymentAmount,
            date: new Date().getTime(),
            txRef: booking.id
          }
          push(walletHistoryRef(booking.driver), details);
        }  
      },{onlyOnce: true});

      if(booking.customer_token){
        RequestPushMsg(
          booking.customer_token,
          {
            title: store.getState().languagedata.defaultLanguage.notification_title,
            msg: store.getState().languagedata.defaultLanguage.success_payment,
            screen: 'BookedCab',
            params: { bookingId: booking.id }
          }
        );
      }

        if(booking.driver_token){
          RequestPushMsg(
            booking.driver_token,
            {
                title: store.getState().languagedata.defaultLanguage.notification_title,
                msg: store.getState().languagedata.defaultLanguage.success_payment,
                screen: 'BookedCab',
                params: { bookingId: booking.id }
            }
          );
        } 
      booking.status = 'PAID';
    } else{
      booking.status = 'PENDING';
    }

    update(singleBookingRef(booking.id), booking);
  }
};